// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { EMRHubType } from "../../types";
import { getEMRHubById } from "../../api";

export const useEMRHubById = (
  clinicId: string | undefined,
  hubId: string | undefined
) => {
  const { getToken } = useTokenAccess();

  return useQuery<EMRHubType>({
    queryKey: ["emr-hubs", clinicId, hubId],
    queryFn: async () => {
      if (!clinicId || !hubId) throw new Error();
      const token = await getToken();
      return getEMRHubById(token, clinicId, hubId);
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
